import request from "@/utils/request";

export function myPapers(data) {
  return request({
    url: "/student/paper/myPapers",
    method: "post",
    data,
  });
}

export function start(data) {
  return request({
    url: "/student/paper/start",
    method: "post",
    data,
  });
}
export function saveData(data) {
  return request({
    url: "/student/paper/saveData",
    method: "post",
    data,
    loading:false
  });
}
export function saveCard(data) {
  return request({
    url: "/student/paper/saveCard",
    method: "post",
    data,
    headers:{
      'Content-Type':'application/json;charset=UTF-8'
    }
  });
}
export function delCard(data) {
  return request({
    url: "/student/paper/delCard",
    method: "post",
    data,
  });
}
export function submit(data) {
  return request({
    url: "/student/paper/submit",
    method: "post",
    data,
  });
}
export function getHistory(data) {
  return request({
    url: "/student/paper/getHistory",
    method: "post",
    data,
  });
}
export function myDbTests(data) {
  return request({
    url: "/student/test/list",
    method: "post",
    data,
  });
}
//个人自测
export function testStart(data) {
  return request({
    url: "/student/test/start",
    method: "post",
    data,
  });
}
export function testSaveData(data) {
  return request({
    url: "/student/test/saveData",
    method: "post",
    data,
  });
}
//我的错题
export function ctList(data) {
  return request({
    url: "/student/test/myErrorQuestion/list",
    method: "post",
    data,
  });
}
export function ctDelete(data) {
  return request({
    url: "/student/test/myErrorQuestion/delete",
    method: "post",
    data,
  });
}

